<template>
  <div class="monit-page">
    <div class="monit-main row justify-content-sb">
      <h3 v-if="mobile" class="page-title col-xs-12 col-sm-6 pt-2">
        {{ pageTitle }}
      </h3>
      <toolbar v-if="mobile" class="col-xs-12 col-sm-6" :is-mobile="mobile" :filter-opt="filterOpt"
        :filter-tag="filterBy === 100 ? true : false" :filters="filters" :is-filtering="isFiltering"
        @filter-by="onFilterBy" @search="searchBy" @clear-search="onClearSearch" @reset="resetProp"
        @type-change="changeTypeMobile" :type-filtering="
          tab1.toLowerCase() === 'exibir todos' ? '' : tab1.toLowerCase()
        " :is-searching="isSearching" :not-exists="showErrorNotFound" :not-search="showErrorNotSearch" />

      <!-- Filtros mobile -->
      <div v-if="mobile" class="mobile-filter-bar col-xs-12">
        <b-btn size="sm" variant="outline-secondary" class="mobile-filter-toggle" @click="showMobileFilters = !showMobileFilters">
          <filter-outline-icon title="" /> Filtros
          <span v-if="mobileFilterModel.length || mobileFilterStatus !== null" class="filter-active-dot"></span>
        </b-btn>
        <b-collapse v-model="showMobileFilters">
          <div class="mobile-filter-panel">
            <div v-if="actuatorsModels.length && !modelFilter">
              <div class="filter-section-label d-flex justify-content-between align-items-center">
                <span>Modelo</span>
                <b-form-checkbox v-model="excludeSelectedModels" switch size="sm" class="mb-0">
                  Ocultar
                </b-form-checkbox>
              </div>
              <b-form-checkbox-group v-model="mobileFilterModel" name="mobile-model-filters"
                button-variant="info" size="sm" stacked>
                <b-form-checkbox v-for="opt in actuatorsModels" :key="opt.value" :value="opt.value">
                  {{ opt.text }} <span class="model-count">({{ opt.count }})</span>
                </b-form-checkbox>
              </b-form-checkbox-group>
            </div>
            <div class="filter-section-label mt-2">Status</div>
            <b-form-radio-group v-model="mobileFilterStatus" buttons button-variant="light" size="sm">
              <b-form-radio :value="null">Todos</b-form-radio>
              <b-form-radio :value="1">Ativados</b-form-radio>
              <b-form-radio :value="0">Desativados</b-form-radio>
              <b-form-radio :value="2">Indefinido</b-form-radio>
              <b-form-radio :value="11">Manual</b-form-radio>
              <b-form-radio :value="'rf'">Sem RF</b-form-radio>
              <b-form-radio :value="'fbalarm'">Alarme feedback</b-form-radio>
              <b-form-radio :value="'intertravamento'">Intertravamento</b-form-radio>
            </b-form-radio-group>
          </div>
        </b-collapse>
      </div>
      <div v-if="loading" class="col-xs-12 center-xs mt-2">
        <spinner /> Aguarde...
      </div>

      <div v-if="showErrorNotFound" class="
          EmptyRequest
          w-100
          p-0
          row
          center-xs center-md center-sm center-xs
          mt-3
        ">
        <img :src="emptyIcon" class="empty" />
        <span>Não há atuadores para exibir. Para cadastrar um novo,
          <router-link to="/registers/equips">clique aqui</router-link>.
        </span>
      </div>

      <div v-if="showErrorNotSearch && !showErrorNotFound" class="EmptyRequest row center-xs mx-2 md-12 w-100 p-0 mt-3"
        style="text-align: left">
        <img :src="searchIcon" class="empty" />
        <span>
          Não foi possível realizar a busca,
          <b-link @click="resetSearch"> clique aqui </b-link> para voltar a
          exibir os atuadores.
        </span>
      </div>

      <div class="container-cards">
        <div v-for="(item, index) in orderedList" :key="index" class="space-card">
          <router-link :to="`${cardLinkBase}/${type ? type : ''}`" @click.native="
            () => {
              openDetailsDialog(item);
              selectedCard = index;
            }
          ">
            <div :class="`monitCard ${BGRF(item.RF_STAT, item.UPDATE)}  ${
              selectedCard == index ? 'activeCard' : ''
            } ${isPivot(item) ? 'is-pivot' : ''} ${alertClass(item)}`">
              <div :class="`top ${topBarClass(item)}`"></div>
              <pivot-dial v-if="isPivot(item)" class="pivot-card-dial" :angle="pivotAngle(item)"
                :percent="pivotPercent(item)" :variant="pivotVariant(item)" :work-mode="pivotWorkMode(item)"
                :reversed="pivotReversed(item)" :pressurized="pivotPressurized(item)" :size="46" />
              <flow-gauge v-if="hasFlowGauge(item)" class="flow-gauge-mount" :flow="item.FLOW"
                :min-flow="item.MIN_FLOW" :max-flow="item.MAX_FLOW" :active="!!item.OPEN" :size="48" />
              <div class="monit-name">
                {{ item.NAME }}
                <div v-if="isPivot(item)" class="monit-model">
                  {{ item.MODEL }} · {{ pivotPositionFailed(item) ? "falha no sensor" : pivotAngle(item) + "°" }}
                </div>
                <div v-else-if="item.MODEL" class="monit-model">{{ item.MODEL }}</div>
              </div>
              <span v-if="cardInfoLines(item).length" class="info">
                <template v-for="(line, li) in cardInfoLines(item)">
                  <br v-if="li > 0" :key="`br-${li}`" />
                  <span :key="li" :class="line.class">{{ line.text }}</span>
                </template>
              </span>

              <div class="monit-badges" v-if="(item.MANUAL && item.RF_STAT !== 8) || (item.ID < 1000000 && item.RF_STAT !== 8) || feedbackOk(item)">
                <div class="monit-detail" v-if="item.MANUAL && item.RF_STAT !== 8">
                  MANUAL
                </div>
                <div class="monit-detail" v-if="item.ID < 1000000 && item.RF_STAT !== 8">
                  BOMBA
                </div>
                <div v-if="feedbackOk(item)" class="monit-detail feedback-ok">
                  Feedback ok
                </div>
              </div>
              <div v-show="formatStatusDir(item)" :class="`warn-card ${hasFlowGauge(item) ? 'warn-card--gauge-clear' : ''}`">
                <alert-icon title="" style="font-size: 0.9em" /><span>{{
                formatStatusDir(item)
                }}</span>
              </div>
              <div v-if="feedbackStatus(item)" :class="`warn-card warn-feedback ${feedbackStatus(item) === 'Intertravamento ativo' ? 'warn-feedback--error' : ''} ${hasFlowGauge(item) ? 'warn-card--gauge-clear' : ''}`">
                <alert-icon title="" style="font-size: 0.9em" /><span>{{ feedbackStatus(item) }}</span>
              </div>
              <div v-if="isPivot(item) && pivotPositionFailed(item)" :class="`warn-card warn-feedback warn-feedback--error ${hasFlowGauge(item) ? 'warn-card--gauge-clear' : ''}`">
                <alert-icon title="" style="font-size: 0.9em" /><span>Falha no sensor de posição</span>
              </div>
              <footer>
                <!-- item.UPDATE é quando o firmware regravou o snapshot do atuador, não
                     quando o DIR-PIR comunicou de fato -- dirLastComm() (GENERIC "Última
                     comunicação:" do DIR_INFO cruzado pelo backend, issue #456) é o dado
                     real, mesma pegadinha já resolvida pra #/monitoring/dirs na #455.
                     Só pra PIR -- atuadores comuns continuam com item.UPDATE. -->
                <div v-if="isPivot(item) && dirLastComm(item) === 'Nunca'" id="date" class="date-never-synced">
                  Aguardando comunicação
                </div>
                <div v-else id="date">{{ formatUpdate((isPivot(item) && dirLastComm(item)) || item.UPDATE) }}</div>
                <div :class="`status ${setBG(item)} ${isPivot(item) ? 'status-pivot' : ''}`"
                  :title="isPivot(item) ? pivotStatusLabel(item) : null">
                  {{ selectInfoStatus(item) }}
                </div>
              </footer>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- BARRA DIREITA -->
    <div class="monit-helper" v-if="!mobile">
      <div class="container-helper">
        <header>
          <div class="header-group">
            <water-icon title="" customHeight="20px" />
            <div class="title-monit-helper">{{ pageTitle }}</div>
          </div>

          <toolbar v-if="!mobile" :is-mobile="mobile" :filter-opt="filterOpt" :is-filtering="isFiltering"
            @filter-by="onFilterBy" @search="searchBy" @clear-search="onClearSearch" :type-filtering="
              tab1.toLowerCase() === 'exibir todos' ? '' : tab1.toLowerCase()
            " :is-searching="isSearching" :not-exists="showErrorNotFound" :not-search="showErrorNotSearch" />
        </header>
        <div class="filter-container mt-2">
          <div class="col-xs-12 filter-title">
            <h5>{{ listLabel }}</h5>
            <span>{{ orderedList.length }}</span>
          </div>

          <div v-if="actuatorsModels.length && !modelFilter" class="filter-section p-2">
            <div class="filter-section-label d-flex justify-content-between align-items-center">
              <span>Filtrar por modelo</span>
              <b-form-checkbox v-model="excludeSelectedModels" switch size="sm" class="mb-0">
                Ocultar selecionados
              </b-form-checkbox>
            </div>
            <b-form-checkbox-group id="checkbox-group-1" v-model="selectedCheckbox"
              name="filters" button-variant="info" size="sm" stacked>
              <b-form-checkbox v-for="opt in actuatorsModels" :key="opt.value" :value="opt.value">
                {{ opt.text }} <span class="model-count">({{ opt.count }})</span>
              </b-form-checkbox>
            </b-form-checkbox-group>
          </div>

          <div class="filter-section p-2">
            <div class="filter-section-label">Filtrar por status</div>
            <b-form-radio-group v-model="selectedRadiusButton" buttons button-variant="light" size="sm" stacked>
              <b-form-radio :value="null">Exibir todos</b-form-radio>
              <b-form-radio :value="1">Ativados ({{ alerts[1].length }})</b-form-radio>
              <b-form-radio :value="0">Desativados ({{ alerts[0].length }})</b-form-radio>
              <b-form-radio :value="2">Indefinido ({{ alerts[2].length }})</b-form-radio>
              <b-form-radio :value="11">Em manual ({{ alerts[11].length }})</b-form-radio>
              <b-form-radio :value="'rf'">Prob. comunicação ({{ alerts["rf"].length }})</b-form-radio>
              <b-form-radio :value="'fbalarm'">Alarmes de feedback ({{ alerts["fbalarm"].length }})</b-form-radio>
              <b-form-radio :value="'intertravamento'">Intertravamento ativo ({{ alerts["intertravamento"].length }})</b-form-radio>
            </b-form-radio-group>
          </div>
        </div>
      </div>
    </div>
    <!-- O painel do PIR é sempre o do pivô, também em /monitoring/actuators
         (onde o card fica simples): o painel genérico oferece LIGAR/DESLIGAR,
         e o PIR é operado só por agenda. -->
    <actuator-details :item="selected" :status-color="variant" :updated="updated" :variant="variant" :is-mobile="mobile"
      :show-details="showDetails" :is-pivot="pirIsPivot(selected)" @close-details="closeDetails" />
  </div>
</template>

<script>
import { updateFormatter } from "@/pages/components/helpers";
import { monit, pirSchedules } from "@/api";
import EventBus from "@/pages/components/eventBus";
import PivotDial from "./components/PivotDial.vue";
import FlowGauge from "./components/FlowGauge.vue";
import {
  isPivot as pirIsPivot,
  pivotAngle as pirAngle,
  pivotPercent as pirPercent,
  pivotVariant as pirVariant,
  pivotStatusLabel as pirStatusLabel,
  pivotStatusShortLabel as pirStatusShortLabel,
  pivotBgClass as pirBgClass,
  pivotWorkMode as pirWorkMode,
  pivotReversed as pirReversed,
  pivotPositionFailed as pirPositionFailed,
  pivotPressurized as pirPressurized,
  pivotPressureShort as pirPressureShort,
  PIR_SCHEDULE_STATUS_LABELS,
  PIR_SCHEDULE_LIVE_STATUSES,
  PIR_SCHEDULE_ANGLE_REACHED,
  pirScheduleOverride,
  pirSchedulePosition,
} from "./pirHelpers";

// Status da agenda (enum AGN_PIR_* do fw_cir, agn_pir.h) que valem a pena
// aparecer no card compacto -- 9 é "em execução" (mostra progresso), os
// demais (5=conflito, 6=bloqueada por ponta, 7=bloqueada por sensor,
// 8=PIR indisponível, 10=falha de segurança) são "tentaria rodar agora mas
// está bloqueada" (mostra o motivo); 11=posição final atingida é a ocorrência
// encerrada pela chegada, ainda dentro da janela. Os outros (expirada/parada/
// em espera/dia não selecionado) não dizem nada de novo pra quem só está
// olhando o card, ficam de fora pra não poluir.
const PIR_SCHEDULE_CARD_STATUSES = PIR_SCHEDULE_LIVE_STATUSES;
export default {
  name: "monit-actuators",
  components: {
    PivotDial,
    FlowGauge,
  },
  props: {
    mobile: Boolean,
    modelFilter: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showDetails: false,
      showMobileFilters: false,
      mobileFilterModel: [],
      mobileFilterStatus: null,
      backendNow: null,
      selectedCard: null,
      loading: true,
      selected: {},
      filterBy: 100,
      tab1: "",
      tab2: "",
      fullList: [],
      list: [],
      emptyIcon: require("../../../assets/icons/Empty.svg"),
      searchIcon: require("../../../assets/icons/search.svg"),
      type: null,
      missingResults: false,
      isSearching: false,
      isFiltering: false,
      filter: "",
      filterOpt: "",
      actuatorsModels: [],
      filters: [
        { value: 1, text: "Ativados" },
        { value: 0, text: "Desativados" },
        { value: 11, text: "Em manual" },
        { value: "rf", text: "Problemas de comunicação" },
        { value: "fbalarm", text: "Alarmes de feedback" },
        { value: "intertravamento", text: "Intertravamento ativo" },
      ],
      items: [],
      controller: null,
      timeout: null,
      alerts: {
        1: [],
        0: [],
        2: [],
        1000000: [],
        11: [],
        rf: [],
        fbalarm: [],
        intertravamento: [],
      },
      showErrorNotFound: false,
      showErrorNotSearch: false,
      selectedCheckbox: [],
      // "Anti-filtro": quando true, os modelos marcados são OCULTADOS em
      // vez de serem os únicos exibidos (ex.: marcar "VIRTUAL" some com
      // os cards desse modelo, em vez de mostrar só eles).
      excludeSelectedModels: false,
      selectedRadiusButton: "",
      pirScheduleMonitoring: [],
      pirScheduleTimeout: null,
    };
  },
  created() {
    this.applyModelFilter(this.modelFilter);
    this.controller = new AbortController();
    this.selectedRadiusButton = null;
    this.monitLoop();
    this.pollPirSchedules();
    if (!this.type) {
      this.tab1 = "EXIBIR TODOS";
    }
  },
  beforeDestroy() {
    this.controller.abort();
    clearTimeout(this.timeout);
    this._pirScheduleDestroyed = true;
    clearTimeout(this.pirScheduleTimeout);
  },
  watch: {
    modelFilter(newValue) {
      // /monitoring/actuators e /monitoring/pir reaproveitam a mesma instância de
      // componente (mesmo componentName na rota) — created() não roda de novo na
      // troca de rota, então o preset do filtro precisa reagir à mudança da prop.
      this.applyModelFilter(newValue);
    },
    selectedCheckbox(newValue) {
      if (!this.mobile) {
        this.isActive(this.items);
      }
    },
    selectedRadiusButton(v) {
      if (v != null) {
        this.onFilterBy(v);
      } else {
        this.showErrorNotSearch = false;
        this.onFilterBy(100);
      }
    },
    mobile(newValue, oldValue) {
      if (newValue) {
        this.showErrorNotSearch = false;
        this.showErrorNotFound = false;
        this.selectedRadiusButton = null;
        this.selectedCheckbox = [];
        this.isSearching = false;
        this.filter = "";
      } else {
        this.resetSearch();
      }
    },
  },
  methods: {
    unitFlow(item_unit_flow) {
      return item_unit_flow ? item_unit_flow : 'm³/h'
    },
    applyModelFilter(modelFilter) {
      this.$emit(
        "title-change",
        modelFilter
          ? (this.mobile ? "M. Pivô Central" : "Monitoramento de Pivô Central")
          : (this.mobile ? "M. de Atuadores" : "Monitoramento de Atuadores")
      );
      this.selectedCheckbox = modelFilter ? [modelFilter] : [];
      this.mobileFilterModel = modelFilter ? [modelFilter] : [];
    },
    pirIsPivot(item) {
      return pirIsPivot(item);
    },
    isPivot(item) {
      // Só aplica o visual de pivô na página dedicada (/monitoring/pir);
      // em /monitoring/actuators um item MODEL=PIR deve renderizar como qualquer outro atuador.
      return this.modelFilter === "PIR" && pirIsPivot(item);
    },
    // Status ao vivo da agenda do PIR (issue #445), pra aparecer direto no
    // card compacto -- item.ID (equipamento) == AGN_PIR.FK_VALVE, mesma
    // relação já usada em PivotSchedule.vue.
    pollPirSchedules() {
      pirSchedules
        .monitoring()
        .then((ret) => {
          this.pirScheduleMonitoring = ret || [];
        })
        .catch((err) => console.log(err))
        .then(() => {
          if (!this._pirScheduleDestroyed) {
            this.pirScheduleTimeout = setTimeout(this.pollPirSchedules, 5000);
          }
        });
    },
    // Se houver mais de uma agenda "relevante" pro mesmo PIR nesse instante
    // (não deveria, é exatamente o caso de CONFLITO), mostra a primeira --
    // o card é só um resumo, o detalhe completo mora na aba Agenda.
    pirScheduleFor(item) {
      const relevant = this.pirScheduleMonitoring.filter(
        (m) => Number(m.FK_VALVE) === Number(item.ID) && PIR_SCHEDULE_CARD_STATUSES.includes(Number(m.STATUS))
      );
      return relevant.length ? relevant[0] : null;
    },
    pirScheduleLabel(m, item) {
      const override = pirScheduleOverride(m, item);
      if (override) return `${m.NAME} (${override.label})`;
      const pos = pirSchedulePosition(m);
      if (Number(m.STATUS) === 9) {
        // Tudo na mesma linha: o card tem altura fixa (ver .monitCard).
        let extra = "";
        if (pos.unavailable) extra = " · posição indisponível";
        else if (pos.remaining) extra = ` · faltam ${pos.remaining}`;
        return `${m.NAME} (${m.ELAPSED}/${m.DURATION_MIN} min${extra})`;
      }
      if (Number(m.STATUS) === PIR_SCHEDULE_ANGLE_REACHED) {
        const at = pos.target && pos.target.match(/às\s+(\d{1,2}:\d{2})/);
        const label = PIR_SCHEDULE_STATUS_LABELS[PIR_SCHEDULE_ANGLE_REACHED];
        return `${m.NAME} (${label}${at ? ` ÀS ${at[1]}` : ""})`;
      }
      return `${m.NAME} (${PIR_SCHEDULE_STATUS_LABELS[m.STATUS] || ""})`;
    },
    pivotStatusLabel(item) {
      return pirStatusLabel(item);
    },
    pivotAngle(item) {
      return pirAngle(item);
    },
    pivotPositionFailed(item) {
      return pirPositionFailed(item);
    },
    pivotPercent(item) {
      return pirPercent(item);
    },
    pivotVariant(item) {
      return pirVariant(item);
    },
    pivotWorkMode(item) {
      return pirWorkMode(item);
    },
    pivotReversed(item) {
      return pirReversed(item);
    },
    pivotPressurized(item) {
      return pirPressurized(item);
    },
    pivotPressure(item) {
      return pirPressureShort(item);
    },
    // Vazão depende do hidrômetro (item.HYDRO) -- pressão e percentímetro são
    // leituras do próprio PIR, independentes disso. Antes ficavam aninhadas
    // dentro do mesmo v-if de HYDRO e a pressão sumia do card quando o PIR
    // não tinha hidrômetro associado.
    cardInfoLines(item) {
      if (item.RF_STAT === 8) return [];
      const lines = [];
      if (item.HYDRO) {
        lines.push({ text: `${item.FLOW}${this.unitFlow(item.UNIT_FLOW)}`, class: "pivot-pressure-card" });
      }
      if (this.isPivot(item)) {
        const pressure = this.pivotPressure(item);
        if (pressure) lines.push({ text: pressure, class: "pivot-pressure-card" });
        const percent = this.pivotPercent(item);
        if (percent !== null) lines.push({ text: `Percentímetro: ${percent}%`, class: "pivot-pressure-card" });
        const sched = this.pirScheduleFor(item);
        if (sched) {
          const override = pirScheduleOverride(sched, item);
          const warn = override || pirSchedulePosition(sched).unavailable;
          lines.push({
            text: `Agenda: ${this.pirScheduleLabel(sched, item)}`,
            class: warn ? "pivot-pressure-card font-weight-bold" : "pivot-pressure-card",
          });
        }
        // Sinal/bateria são do DIR-PIR (dispositivo físico), não do atuador --
        // item.DIR_INFO é cruzado pelo backend (ValveController.js, issue #456)
        // com o JSON do dispositivo (mesmo dado que #/monitoring/dirs já mostra).
        const signal = this.dirSignal(item);
        if (signal !== null) lines.push({ text: `Sinal: ${signal}%`, class: "pivot-pressure-card" });
        if (item.DIR_INFO && item.DIR_INFO.BAT != null) {
          lines.push({ text: `Bateria: ${item.DIR_INFO.BAT} V`, class: "pivot-pressure-card" });
        }
      }
      // Intertravamento (FEEDBACK_ERR_ENABLED) é config de CAD_VALVE/CAD_PUMP,
      // não vem no JSON do atuador -- cruzado pelo backend em ValveController.js
      // (mesmo espírito do DIR_INFO acima, issue #459) e só faz sentido mostrar
      // quando há sensor de feedback associado (senão a config é inerte).
      if (item.GENERIC && item.GENERIC.some((g) => g.NAME === "Feedback:")) {
        lines.push({
          text: `Intertravamento: ${item.FEEDBACK_ERR_ENABLED ? "habilitado" : "desabilitado"}`,
          class: "pivot-pressure-card",
        });
      }
      // Sensor de pressão associado (FK_SENSOR_PRESSURE) -- mesmo espírito do
      // DIR_INFO/FEEDBACK_ERR_ENABLED acima: leitura cruzada pelo backend a
      // partir do JSON do próprio sensor, não do atuador (issue #458). Só o
      // valor no card, sem o nome do sensor (a pedido do usuário).
      if (item.PRESSURE_SENSOR_INFO) {
        const { VALUE, UNIT } = item.PRESSURE_SENSOR_INFO;
        lines.push({
          text: `${VALUE}${UNIT || ""}`,
          class: "pivot-pressure-card",
        });
      }
      return lines;
    },
    // Mesmo cálculo de sinal 0-100% já usado em Dirs/View.vue -- duplicado aqui
    // de propósito (mesmo padrão do resto do arquivo, ver ActuatorDetails.vue),
    // não vale a pena um helper compartilhado só por isso.
    calculatePercentage(value, ref) {
      if (!ref) return 0;
      let percent = (value * 100) / ref;
      if (percent > 100) return 100;
      else if (percent < 0) return 0;
      else return parseInt(percent);
    },
    dirSignal(item) {
      const rf = item.DIR_INFO && item.DIR_INFO.RF;
      if (!rf || !rf.ack || rf.ack.length !== 2) return null;
      return this.calculatePercentage(rf.ack[0], rf.ack[1]);
    },
    // Última comunicação REAL com o DIR-PIR (GENERIC do DIR_INFO cruzado pelo
    // backend, issue #456) -- não confundir com item.UPDATE, que é só quando o
    // firmware regravou o snapshot do atuador (mesma pegadinha da issue #455).
    dirLastComm(item) {
      const generic = item.DIR_INFO && item.DIR_INFO.GENERIC;
      if (!generic) return null;
      const found = generic.find((g) => g.NAME === "Última comunicação:");
      return found ? found.VALUE : null;
    },
    // Em modo Local o DIR não sabe que a bomba está rodando (item.OPEN fica
    // falso), mas a leitura física de pressão continua válida — sem isso, um
    // PIR pressurizado em Local caía no filtro "Desativados" (issue #437).
    isActivated(item) {
      if (item.OPEN == 1) return true;
      return this.isPivot(item) && !item.OPEN && pirPressurized(item);
    },
    selectCard(item, index) {
      this.selectedCard = index;
      openDetailsDialog(item);
    },
    closeDetails() {
      this.showDetails = false;
      this.selectedCard = null;
      this.selected = {};
    },
    resetSearch() {
      this.selectedCheckbox = [];
      this.selectedRadiusButton = null;
      EventBus.cleanInputSearch();
      this.filter = "";
      // this.resetDropdown();
      this.isSearching = false;
      this.items = this.fullList;
      this.showErrorNotSearch = false;
      this.resetProp();
      this.resetDropdown();
      this.clearSearchInput();
    },
    onClearSearch() {
      this.filter = "";
      this.resetDropdown();
    },
    // selectDropdownItem(option) {
    //   this.type = option;
    //   this.clearSearchInput();
    // },
    changeTypeMobile(t) {
      this.type = t;
    },
    resetProp() {
      this.onFilterBy(100);
    },
    resetDropdown() {
      this.type = null;
      this.tab1 = "EXIBIR TODOS";
      this.title = "ALL";
      this.isSearching = false;
      // this.filter=""
      this.showErrorNotSearch = false;
      this.items = this.fullList;
    },
    clearSearchInput() {
      if (!!this.$children[0] && this.$children[0].length > 0) {
        this.$children[0].clearText();
      }
      this.isSearching = false;
      this.items = this.fullList;
    },
    isSearchBombs(result) {
      let filter;
      filter = result.filter((item) => item.ID < 1000000);
      if (filter.length) {
        this.showErrorNotSearch = false;
        return filter;
      } else {
        this.showErrorNotSearch = true;
        return [];
      }
    },
    isSearchActuators(result) {
      let filter;
      filter = result.filter((item) => item.ID > 1000000);
      if (filter.length) {
        this.showErrorNotSearch = false;
        return filter;
      } else {
        this.showErrorNotSearch = true;
        return [];
      }
    },
    isSearchCheckbox(result) {
      if (this.mobile) {
        let filter;
        filter = result.filter((item) => item.ID > 1000000);
        if (filter.length) {
          this.showErrorNotSearch = false;
          return filter;
        } else {
          this.showErrorNotSearch = true;
          return [];
        }
      } else {
        let results = [];
        if (this.excludeSelectedModels) {
          results = result.filter(
            (item) => !this.selectedCheckbox.includes(item.MODEL)
          );
        } else {
          for (let checkbox of this.selectedCheckbox) {
            let filter = result.filter((item) => item.MODEL === checkbox);
            results.push(...filter);
          }
        }
        if (results.length) {
          this.showErrorNotSearch = false;
          return results.sort((a, b) => a.ID - b.ID);
        } else {
          this.showErrorNotSearch = true;
          return [];
        }
      }
    },
    isSearch(result) {
      let filter;
      filter = result.filter((item) => {
        if (item.MODEL && item.MODEL.indexOf(this.filter) > -1) {
          return true;
        } else if (item.DIR && item.DIR.indexOf(this.filter) > -1) {
          return true;
        } else if (item.ID && item.ID.indexOf(this.filter) > -1) {
          return true;
        } else {
          return item.NAME.indexOf(this.filter) > -1;
        }
      });
      if (filter.length) {
        this.showErrorNotSearch = false;
        return filter;
      } else {
        this.showErrorNotSearch = true;
        return [];
      }
    },
    isActive(result) {
      let actuators = [];
      if (
        !this.mobile &&
        !!this.selectedCheckbox &&
        this.selectedCheckbox.length > 0
      ) {
        this.isFiltering = false;
        actuators = this.isSearchCheckbox(result);
        if (result.length) {
        }
      } else if (
        !this.mobile &&
        !!this.selectedCheckbox &&
        !this.selectedCheckbox.length
      ) {
        this.tab1 = "EXIBIR TODOS";
        this.title = "ALL";
        this.isFiltering = false;
        actuators = this.fullList;
      } else if (!this.mobile) {
        this.selectedRadiusButton = null;
        this.selectedCheckbox = [];
        this.tab1 = "EXIBIR TODOS";
        this.title = "ALL";
        this.isFiltering = false;
        actuators = this.fullList;
      }
      if (this.mobile && this.type === "bombas") {
        this.selectedRadiusButton = null;
        this.tab1 = `BOMBAS`;
        // this.clearSearch();
        this.title = "";
        if (result.length) {
          actuators = this.isSearchBombs(result);
        }
      } else if (this.mobile && this.type === "atuadores") {
        this.selectedRadiusButton = null;
        this.tab1 = "ATUADORES";
        this.title = "";
        // this.clearSearch();
        if (result.length) {
          actuators = this.isSearchActuators(result);
        }
      } else if (this.mobile && !this.type) {
        this.selectedRadiusButton = null;
        this.selectedCheckbox = [];
        this.tab1 = "EXIBIR TODOS";
        this.title = "ALL";
        actuators = this.fullList;
      }
      return actuators;
    },
    monitLoop() {
      monit
        .actuator(this.controller)
        .then((res) => {
          this.backendNow = Date.parse(res.headers.get("date"));
          return res.json();
        })
        .then((ret) => {
          this.loadFilterModel(ret);
          let list = ret;
          this.fullList = list;
          if (this.isSearching && this.validFilter && list.length) {
            this.items = this.isSearch(list);
          } else {
            this.items = list;
          }
          if (this.loading) this.loading = false;
          if (Object.keys(this.selected).length && this.selected.ID) {
            this.selected =
              this.items.filter((e) => e.ID == this.selected.ID)[0] ||
              this.selected;
          }
        })
        .then((_) => {
          if (!this.loading && !this.items.length && !this.showErrorNotSearch) {
            this.showErrorNotFound = true;
          } else {
            this.showErrorNotFound = false;
          }
        })
        .then((ret) => {
          if (ret !== "AbortError") {
            this.timeout = setTimeout(this.monitLoop, 2000);
          }
        })
        .catch((err) => {
          console.error(err);
          return err.name;
        });
    },
    formatUpdate(update) {
      return updateFormatter(update);
    },
    setBG(item) {
      if (item && typeof item === "object" && this.isPivot(item)) {
        return pirBgClass(item);
      }
      if (item == "rf") return "bg-rf";
      else if (item == 1000000) return "bg-pacific-blue";
      else if (item == 11) return "bg-orange";
      else if (item == 1) return "bg-3v3";
      else if (!item) return "bg-black";
      if (item == 0 || !item.OPEN) return "bg-black-body";
      else if (item.OPEN == 2) return "bg-grey";
      else if (item == 11) return "bg-orange";
      return "bg-3v3";
    },
    // Barra superior do card: mesma cor do setBG() para desligado/indefinido, mas
    // quando há gauge de vazão (item.HYDRO) a cor segue a mesma faixa do gauge
    // (vermelho/verde/amarelo) — o status textual do rodapé fica simples de propósito.
    topBarClass(item) {
      const base = this.setBG(item);
      if (base !== "bg-3v3" || !item || typeof item !== "object" || !this.hasFlowGauge(item)) {
        return base;
      }
      const isValve = item.ID > 1000000;
      if (isValve && item.FLOW < item.MIN_FLOW) return "bg-red-body";
      if (isValve && item.MAX_FLOW && item.FLOW > item.MAX_FLOW) return "bg-yellow";
      if (!isValve && !item.FLOW) return "bg-red-body";
      return base;
    },
    selectInfoStatus(item) {
      if (item && typeof item === "object" && this.isPivot(item)) {
        return pirStatusShortLabel(item);
      }
      if (item == "rf") return "bg-rf";
      else if (item == 1000000) return "bg-pacific-blue";
      else if (item == 11) return "bg-orange";
      else if (item == 1) return "ATIVADO";
      else if (!item) return "bg-black";
      if (item == 0 || !item.OPEN) return "DESATIVADO";
      else if (item.OPEN == 2) return "INDEFINIDO";
      else if (item == 11) return "bg-orange";
      return "ATIVADO";
    },
    BGRF(stat, update) {
      switch (stat) {
        case 0:
          return "bg3v3";
        // case 7:
        //   return "bg-yellow";
        case 8:
          return "bg-red-body";
        case 9:
          return "bg-black-body";
        default:
          return "";
      }
    },
    feedbackOk(item) {
      if (!item.GENERIC) return false;
      const fb = item.GENERIC.find(g => g.NAME === 'Feedback:');
      if (!fb) return false;
      return fb.VALUE === 'Ativo confirmado' || fb.VALUE === 'Inativo confirmado';
    },
    feedbackStatus(item) {
      if (!item.GENERIC) return null;
      const fb = item.GENERIC.find(g => g.NAME === 'Feedback:');
      if (!fb) return null;
      if (fb.VALUE === 'Ativo confirmado' || fb.VALUE === 'Inativo confirmado') return null;
      if (fb.VALUE === 'Erro de feedback') return 'Intertravamento ativo';
      return fb.VALUE;
    },
    formatStatusDir(item) {
      switch (item.RF_STAT) {
        case 8:
          return ` O DIR ${item.DIR} está sem comunicar.`;
        case 9:
          return ` O DIR ${item.DIR} está sem comunicar.`;
        default:
          return null;
      }
    },
    alertClass(item) {
      const fb = this.feedbackStatus(item);
      if (this.formatStatusDir(item) || fb === "Intertravamento ativo" || this.pivotPositionFailed(item)) return "has-alert has-alert--error";
      if (fb) return "has-alert has-alert--warning";
      return "";
    },
    hasFlowGauge(item) {
      return !!item.HYDRO && item.RF_STAT !== 8;
    },
    searchBy(name) {
      this.isSearching = !!name.split(" ").join("");
      this.filter = name.toUpperCase();
    },
    loadFilterModel(actuators) {
      this.loading = true;

      // Conta quantos atuadores existem em cada modelo, pra mostrar ao lado
      // do nome no filtro (ex. "DIR_PS (12)") -- só informativo, não muda
      // o comportamento do filtro em si.
      const counts = {};
      actuators.forEach((actuator) => {
        counts[actuator.MODEL] = (counts[actuator.MODEL] || 0) + 1;
      });

      const models = Object.keys(counts).sort((a, b) => {
        if (a < b) {
          return -1;
        } else if (a > b) {
          return 1;
        }
        return 0;
      })

      const sanitalizedOptions = models.map((model) => {
        return {
          text: model,
          value: model,
          count: counts[model],
        }
      });

      this.actuatorsModels = sanitalizedOptions
      this.loading = false;
    },
    clearSearch() {
      this.showErrorNotSearch = false;
    },
    onFilterBy(value) {
      this.isFiltering = value != 100;
      if (value.text) {
        this.filterOpt = value.text;
      }
      this.filterBy = value;
    },
    openDetailsDialog(item) {
      this.selected = item;
      this.showDetails = true;
    },
  },
  computed: {
    cardLinkBase() {
      return this.modelFilter === "PIR" ? "/monitoring/pir" : "/monitoring/actuators";
    },
    pageTitle() {
      return this.modelFilter === "PIR" ? "Monitore Pivôs" : "Monitore Atuadores";
    },
    listLabel() {
      return this.modelFilter === "PIR" ? "Pivôs" : "Atuadores";
    },
    updated() {
      return Object.keys(this.selected).length && this.selected.UPDATE
        ? this.formatUpdate(this.selected.UPDATE)
        : "";
    },
    // Removia tudo após o 2º segmento do nome da classe (ex: "bg-pacific-blue"
    // virava "pacific" -> "bg-pacific", classe inexistente) — isso deixava o
    // cabeçalho e o botão "Fechar" do painel de detalhes com texto branco
    // invisível sobre fundo branco para status compostos como pivô
    // pressurizado em modo Local (ver issue #437: nome do atuador some acima
    // das abas, botão Fechar pouco visível).
    variant() {
      return this.setBG(this.selected).replace(/^bg-/, "");
    },
    validSearch() {
      return !!this.filter.split(" ").join("");
    },
    orderedList() {
      let filter = this.filterBy;
      let result = this.items;
      if (result.length && this.type && this.type == "atuadores") {
        result = this.isActive(result);
      } else if (
        result.length &&
        this.type &&
        this.type == "bombas" &&
        !this.selected.ID
      ) {
        result = this.isActive(result);
      }

      if (result.length > 0) {
        result = this.isActive(result);
      }

      this.alerts[1] = result.filter((e) => this.isActivated(e));
      this.alerts[0] = result.filter((e) => !e.OPEN && !this.isActivated(e));
      this.alerts[2] = result.filter((e) => e.OPEN == 2);
      this.alerts[1000000] = result.filter((e) => e.ID < 1000000);
      this.alerts[11] = result.filter((e) => !!e.MANUAL);
      this.alerts["rf"] = result.filter((e) => this.BGRF(e.RF_STAT) != "bg3v3");
      this.alerts["fbalarm"] = result.filter((e) => this.feedbackStatus(e) === "Alarme de feedback");
      this.alerts["intertravamento"] = result.filter((e) => this.feedbackStatus(e) === "Intertravamento ativo");

      if (
        this.isSearching &&
        this.validSearch &&
        result.length &&
        this.selectedRadiusButton == null
      ) {
        result = this.isSearch(result);
        this.alerts[1] = result.filter((e) => this.isActivated(e));
        this.alerts[0] = result.filter((e) => !e.OPEN && !this.isActivated(e));
        this.alerts[2] = result.filter((e) => e.OPEN == 2);
        this.alerts[1000000] = result.filter((e) => e.ID < 1000000);
        this.alerts[11] = result.filter((e) => !!e.MANUAL);
        this.alerts["rf"] = result.filter(
          (e) => this.BGRF(e.RF_STAT) != "bg3v3"
        );
        this.alerts["fbalarm"] = result.filter(
          (e) => this.feedbackStatus(e) === "Alarme de feedback"
        );
        this.alerts["intertravamento"] = result.filter(
          (e) => this.feedbackStatus(e) === "Intertravamento ativo"
        );
      }
      if (
        this.isSearching &&
        this.validSearch &&
        this.selectedRadiusButton !== null
      ) {
        result = this.isSearch(result);
        this.alerts[1] = result.filter((e) => this.isActivated(e));
        this.alerts[0] = result.filter((e) => !e.OPEN && !this.isActivated(e));
        this.alerts[2] = result.filter((e) => e.OPEN == 2);
        this.alerts[1000000] = result.filter((e) => e.ID < 1000000);
        this.alerts[11] = result.filter((e) => !!e.MANUAL);
        this.alerts["rf"] = result.filter(
          (e) => this.BGRF(e.RF_STAT) != "bg3v3"
        );
        this.alerts["fbalarm"] = result.filter(
          (e) => this.feedbackStatus(e) === "Alarme de feedback"
        );
        this.alerts["intertravamento"] = result.filter(
          (e) => this.feedbackStatus(e) === "Intertravamento ativo"
        );
        if (filter != 100) {
          if (this.mobile) {
            result = this.alerts[filter.value];
            try {
              if (!result.length) {
                this.showErrorNotSearch = true;
              } else {
                this.showErrorNotSearch = false;
              }
            } catch (error) {
              console.log("Result -> error :", error);
            }
          } else {
            result = this.isSearch(this.alerts[filter]);
            if (!result.length) {
              this.showErrorNotSearch = true;
            } else {
              this.showErrorNotSearch = false;
            }
          }
        }
      } else if (filter != 100) {
        if (this.mobile) {
          result = this.alerts[filter.value];
          try {
            if (!result.length) {
              this.showErrorNotSearch = true;
            } else {
              this.showErrorNotSearch = false;
            }
          } catch (error) {
            console.log("Result -> error :", error);
          }
        } else {
          result = this.isSearch(this.alerts[filter]);
          if (!result.length) {
            this.showErrorNotSearch = true;
          } else {
            this.showErrorNotSearch = false;
          }
        }
      }
      if (this.mobile) {
        if (this.mobileFilterModel.length > 0) {
          result = this.excludeSelectedModels
            ? result.filter(item => !this.mobileFilterModel.includes(item.MODEL))
            : result.filter(item => this.mobileFilterModel.includes(item.MODEL));
        }
        if (this.mobileFilterStatus !== null) {
          if (this.mobileFilterStatus === 1) result = result.filter(e => this.isActivated(e));
          else if (this.mobileFilterStatus === 0) result = result.filter(e => !e.OPEN && !this.isActivated(e));
          else if (this.mobileFilterStatus === 2) result = result.filter(e => e.OPEN == 2);
          else if (this.mobileFilterStatus === 11) result = result.filter(e => !!e.MANUAL);
          else if (this.mobileFilterStatus === 'rf') result = result.filter(e => this.BGRF(e.RF_STAT) != "bg3v3");
          else if (this.mobileFilterStatus === 'fbalarm') result = result.filter(e => this.feedbackStatus(e) === "Alarme de feedback");
          else if (this.mobileFilterStatus === 'intertravamento') result = result.filter(e => this.feedbackStatus(e) === "Intertravamento ativo");
        }
      }

      return result;
    },
  },
};
</script>

<style scoped>
.model-count {
  color: var(--text-gray-primary, #5f5f5f);
  font-size: 0.85em;
}
.filter-section {
  border-bottom: 1px solid var(--border-grey-color-secondary);
}
.filter-section:last-child {
  border-bottom: none;
}
.filter-section-label {
  font-family: "SourceSansPro_Semibold", Arial, Helvetica, sans-serif;
  font-size: 0.8em;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.04em;
  margin-bottom: 6px;
}
.mobile-filter-bar {
  padding: 4px 8px 0;
}
.mobile-filter-toggle {
  position: relative;
  font-size: 0.85em;
}
.filter-active-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  background: var(--orange-color);
  border-radius: 50%;
  margin-left: 4px;
  vertical-align: middle;
}
.mobile-filter-panel {
  background: #f9f9f9;
  border: 1px solid var(--border-grey-color-secondary);
  border-radius: 4px;
  padding: 10px 12px;
  margin-top: 6px;
}
.monit-name {
  overflow: visible;
}
.pivot-card-dial {
  position: absolute;
  top: 14px;
  right: 8px;
}
.monitCard.is-pivot .monit-name {
  padding-right: 54px;
}
.flow-gauge-mount {
  position: absolute;
  right: 8px;
  bottom: 44px;
}
.monit-model {
  font-size: 0.72em;
  font-weight: normal;
  color: #999;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
  margin-top: 1px;
}
.pivot-pressure-card {
  font-size: 1em;
  font-weight: normal;
  opacity: 0.8;
}
.monit-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 2px 0;
}
.monit-badges .monit-detail {
  margin: 0;
  white-space: nowrap;
}
/* Altura fixa p/ todos os cards, baseada no maior conteúdo possível (nome+modelo,
   vazão + pressão + percentímetro + leitura do sensor de feedback, status de
   feedback, badges MANUAL/BOMBA/Feedback ok e até 2 linhas de alerta) — evita
   cards desalinhados quando um item tem menos informação que os vizinhos na
   grade. Reajustar aqui sempre que uma linha nova entrar em cardInfoLines(). */
.monitCard {
  display: flex;
  flex-direction: column;
  min-height: 260px;
}
.monitCard footer {
  position: static;
  margin-top: auto;
}
/* Selo do PIR: a altura fixa do main.css (19px) cortava rótulos que quebram
   em duas linhas; aqui ele cresce em vez de vazar. */
.monitCard footer .status.status-pivot {
  height: auto;
  min-height: 19px;
  padding: 3px 8px;
  line-height: 1.2;
  text-align: center;
}
@media screen and (max-width: 767px) {
  .monit-badges .monit-detail {
    font-size: 0.72em;
    padding: 1px 4px;
  }
}

/* Hierarquia de alarmes: borda + sombra destacam o card no scan visual da grade,
   sem depender só do texto pequeno do warn-card para notar o problema. */
.monitCard.has-alert {
  border-left: 4px solid transparent;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.18), 0 1px 3px rgba(0, 0, 0, 0.14);
}
.monitCard.has-alert--warning {
  border-left-color: #e07f00;
}
.monitCard.has-alert--error {
  border-left-color: #dc3545;
}
.monitCard .warn-card,
.monitCard .monit-badges {
  display: flex;
  align-items: center;
  gap: 4px;
}
.monitCard .warn-card {
  width: fit-content;
  padding: 1px 6px;
  margin: 2px 0;
  border-radius: 4px;
  background-color: rgba(224, 127, 0, 0.12);
}
/* Cards com gauge de vazão (canto inferior direito, ~56px) precisam que o aviso
   de "sem comunicar"/intertravamento pare antes de invadir a área do gauge. */
.monitCard .warn-card--gauge-clear {
  max-width: calc(100% - 56px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/* Fundo sólido + texto branco: com o tom translúcido antigo (e o texto
   colorido de main.css: .warn-feedback #e07f00 / .warn-feedback--error
   #dc3545), o aviso ficava quase invisível sobre um card já vermelho
   (RF_STAT 8/9 -> bg-red-body, ver PIVO-70 na issue #437) ou cinza-escuro
   (bg-black-body) — cor sobre cor de tom parecido. */
.monitCard .warn-feedback {
  background-color: #e07f00;
  color: #fff;
}
.monitCard .warn-feedback--error {
  background-color: #dc3545;
  color: #fff;
}
/* Fundo sólido (não translúcido) igual .warn-feedback--error acima -- mesmo
   motivo: card já vermelho/preto (bg-red-body/bg-black-body) deixaria um
   texto só colorido ilegível. width:fit-content pq #date (main.css) trava
   max-width:57px, pensado pra uma data curta -- sem isso o fundo cobre uma
   caixa larga fixa em vez do texto real "Aguardando comunicação". */
.monitCard footer #date.date-never-synced {
  width: fit-content;
  max-width: 100%;
  padding: 1px 6px;
  border-radius: 4px;
  background-color: #dc3545;
  color: #fff;
  font-weight: 600;
}

/* Grid fluido: substitui os degraus fixos de largura (25%/50%/100%) de main.css
   por colunas que se adaptam continuamente à largura da tela. */
.container-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 10px;
}
.space-card {
  width: auto;
  max-width: none;
  margin: 0;
}
</style>
